module.exports = __webpack_public_path__ + "static/media/eye-crossed.3b97eecf.svg";